import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	heroHeading: {
		id: 'hero.heading.test',
		defaultMessage: 'Calm your mind.{br}Change your life.',
		description: 'Hero heading',
	},
	heroBody: {
		id: 'hero.body.test',
		defaultMessage:
			'Reduce your stress and anxiety with our award-winning courses, programs and meditations.',
		description: 'Hero heading',
	},
	cta: {
		id: 'homepage.hero.cta',
		defaultMessage: 'Try Calm for Free',
		description: 'Button that takes user to free trial signup flow',
	},
});
